import React from "react";
import translation from "../../../i18n/i18.json";
import vendorAuthStyles from "./VendorAuthentication.css";

export default function VendorLogout() {
  const classes = vendorAuthStyles();
  return (
    <div>
      <div className={classes.msgTxt}>{translation.vendor_logout_msg}</div>
      <div className={classes.bgWrapper}></div>
    </div>
  );
}
